import script from "./SocialFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFeed.vue?vue&type=script&setup=true&lang=js"

import "./SocialFeed.vue?vue&type=style&index=0&id=2511bf0a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2511bf0a"]])

export default __exports__